import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestEditTestIds } from '../../../testids/RestrictionRuleRequestEditTestIds'

export const restrictionRuleRequestEditHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleRequestEditTestIds.restrictionRuleRequestEditPage]: 'Edit a draft restriction-rule change request — adjust the expression, denied access profiles, and approvers before submitting.',
    [RestrictionRuleRequestEditTestIds.btnBackNotEditable]: 'Return to the request detail. The request is no longer editable in its current state.',
  },
}
